import { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/store/state';
import { GameStepsState } from '@/store/modules/gamesteps/state';

export type GameStepsActionContext = ActionContext<GameStepsState, RootState>;

export type Actions = {
  addTotalSteps(context: GameStepsActionContext, totalSteps: number): void;
};

export const actions: ActionTree<GameStepsState, RootState> = {
  addTotalSteps: ({ commit, state }, totalSteps) => {
    const totalStepsState = state.totalSteps ?? undefined;
    if (!totalSteps) {
      commit('setTotalSteps', totalStepsState);
    } else {
      commit('setTotalSteps', totalSteps);
    }
  }
};
